import styled from 'styled-components'
import { Flex, Text } from '@pancakeswap/uikit'

import { ToggleMe } from '@pancakeswap/uikit'

export const ToggleText = styled(Text)`
  font-size: 14px;
  text-transform: uppercase;
  @media (min-width: 1000px) {
    font-size: 14px;
  }
`

export const ToggleHousing = styled.div`
  display: flex;
  width: 100%;

  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  margin-bottom: 16px;
  ${({ theme }) => theme.mediaQueries.md} {
    width: 50%;
  }
`

export const ViewAndSortContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  position: relative;
  justify-content: flex-start;
  padding-left: 1rem;

  ${({ theme }) => theme.mediaQueries.sm} {
    flex-direction: row;
    width: 75%;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 2px;
    padding-left: 0rem;
  }
`
export const ViewAndStaked = styled.div`
  flex-wrap: wrap;
  justify-content: space-between;
  display: flex;
  align-items: center;
  width: 100%;
  display: flex;
  > div {
    padding: 8px 0px;
  }
  ${({ theme }) => theme.mediaQueries.lg} {
    justify-content: flex-end;
    align-items: flex-end;
    width: auto;
    display: flex;
    > div {
      padding: 0;
    }
  }
`

export const StakedOnlyWrapper = styled.div`
  display: flex;

  margin-left: 10px;
  ${Text} {
    margin-left: 8px;
  }
`

export const FarmsHeader = styled(Text)`
  font-weight: 500;
  color: #fff;
  text-align: left;
  margin-bottom: 12px;
  margin-top: 12px;
  text-transform: uppercase;
  font-size: 40px;
  @media (min-width: 768px) {
    font-size: 68px;
    margin-top: 0px;
  }
`

export const LabelWrapper = styled.div`
  > ${Text} {
    font-size: 12px;
  }
`

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 0px;
  ${({ theme }) => theme.mediaQueries.sm} {
    width: auto;
    padding: 0;
  }
`
